<div class="actions">
  <div class="vertical-bar"></div>
  <div
    class="actions__content"
    [wdTooltip]="!isAccountAccessible ? 'CAMPAIGN.ACCOUNTS.ACTIONS.NOT_ACCESSIBLE' : ''"
    [wdTooltipDisable]="isAccountAccessible">
    <app-custom-switcher
      [isChecked]="isAccountEnabled"
      [size]="'small'"
      (checkedValue)="toggleSwitcher()"
      [disabled]="!isAccountAccessible"
      [wdTooltip]="
        isAccountEnabled ? 'CAMPAIGN.ACCOUNTS.ACTIONS.DISABLE' : 'CAMPAIGN.ACCOUNTS.ACTIONS.ENABLE'
      "
      [wdTooltipDisable]="!isAccountAccessible"></app-custom-switcher>

    <button
      class="btn btn--icon"
      (click)="reconnect.emit()"
      [disabled]="disabled || !isAccountAccessible || disableReconnect"
      [wdTooltip]="'CAMPAIGN.ACCOUNTS.ACTIONS.RECONNECT'"
      [wdTooltipDisable]="!isAccountAccessible">
      <svg class="icon btn__icon">
        <use xlink:href="#refresh-icon"></use>
      </svg>
    </button>

    <button
      class="btn btn--icon"
      (click)="editPrivacy.emit()"
      [disabled]="disabled || !isAccountAccessible"
      [wdTooltip]="'CAMPAIGN.ACCOUNTS.ACTIONS.PRIVACY'"
      [wdTooltipDisable]="!isAccountAccessible">
      <svg class="icon btn__icon">
        <use xlink:href="#shield"></use>
      </svg>
    </button>

    <button
      class="btn btn--icon"
      (click)="editLimits.emit()"
      [disabled]="disabled || !isAccountAccessible"
      [wdTooltip]="'CAMPAIGN.ACCOUNTS.ACTIONS.LIMITS'"
      [wdTooltipDisable]="!isAccountAccessible">
      <svg class="icon btn__icon">
        <use xlink:href="#gauge"></use>
      </svg>
    </button>

    <button
      class="btn btn--icon"
      (click)="delete.emit()"
      [disabled]="disableDelete || !isAccountAccessible"
      [wdTooltip]="'CAMPAIGN.ACCOUNTS.ACTIONS.DELETE'"
      [wdTooltipDisable]="!isAccountAccessible">
      <svg class="icon btn__icon">
        <use xlink:href="#remove-basket"></use>
      </svg>
    </button>
  </div>
</div>
